var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_3752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8754 2.87451C20.5425 2.88993 15.4325 5.01522 11.6616 8.78612C7.89071 12.557 5.76542 17.667 5.75 22.9999L31.2468 28.3713L25.8754 2.87451Z",
    fill: "#ED6C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8745 2.87451C31.2074 2.88993 36.3174 5.01522 40.0883 8.78612C43.8592 12.557 45.9845 17.667 45.9999 22.9999L35.9367 29.8388L25.8745 22.9999V2.87451Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8754 43.1254C31.208 43.1097 36.3178 40.9843 40.0885 37.2134C43.8592 33.4425 45.9843 28.3327 45.9998 23H5.75C5.76542 28.3328 7.89071 33.4429 11.6616 37.2138C15.4325 40.9847 20.5425 43.11 25.8754 43.1254Z",
    fill: "#D35230"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.9603 10.062H10.5025C7.21676 13.9337 5.52663 18.9102 5.77492 23.9821C6.02321 29.0541 8.19132 33.8417 11.8395 37.374H23.9603C24.4683 37.3727 24.9551 37.1704 25.3143 36.8113C25.6736 36.4522 25.8762 35.9655 25.8777 35.4575V11.9784C25.8762 11.4705 25.6736 10.9838 25.3143 10.6247C24.9551 10.2656 24.4683 10.0633 23.9603 10.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5199 11.4995H9.40195C6.43903 15.7039 5.21072 20.8885 5.97246 25.9753C6.73419 31.0621 9.42735 35.6595 13.4919 38.8115H22.5219C23.0293 38.8097 23.5155 38.6073 23.8743 38.2485C24.2331 37.8896 24.4355 37.4035 24.4373 36.896V13.4159C24.4358 12.908 24.2332 12.4213 23.8739 12.0622C23.5147 11.7031 23.0279 11.5008 22.5199 11.4995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.52 11.4995H9.40104C6.84689 15.1185 5.5689 19.4841 5.76829 23.9091C5.96768 28.3341 7.63312 32.5671 10.5024 35.9417H22.5209C23.0287 35.9402 23.5153 35.7378 23.8744 35.3787C24.2334 35.0196 24.4358 34.5331 24.4374 34.0253V13.4159C24.4358 12.908 24.2333 12.4213 23.874 12.0622C23.5147 11.7031 23.0279 11.5008 22.52 11.4995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.0828 11.4995H9.39732C6.8437 15.1189 5.56639 19.4848 5.76648 23.9098C5.96658 28.3348 7.63272 32.5676 10.5026 35.9417H21.0838C21.5916 35.9402 22.0782 35.7378 22.4372 35.3787C22.7963 35.0196 22.9987 34.5331 23.0002 34.0253V13.4159C22.9987 12.908 22.7962 12.4213 22.4369 12.0622C22.0776 11.7031 21.5908 11.5008 21.0828 11.4995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.91642 11.4995H21.0836C21.5918 11.4995 22.0793 11.7014 22.4387 12.0608C22.7981 12.4202 23 12.9077 23 13.4159V32.5831C23 33.0914 22.7981 33.5788 22.4387 33.9382C22.0793 34.2976 21.5918 34.4995 21.0836 34.4995H1.91642C1.40816 34.4995 0.920707 34.2976 0.561307 33.9382C0.201908 33.5788 0 33.0914 0 32.5831V13.4159C0 12.9077 0.201908 12.4202 0.561307 12.0608C0.920707 11.7014 1.40816 11.4995 1.91642 11.4995Z",
    fill: "#C43E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4954 15.8075C12.9108 15.7121 14.3142 16.1221 15.4558 16.9644C15.9239 17.3821 16.2909 17.9009 16.529 18.4814C16.767 19.062 16.8699 19.689 16.8298 20.3152C16.845 21.1284 16.6067 21.9261 16.1482 22.5978C15.6843 23.3414 15.0154 23.9352 14.222 24.3077C13.3132 24.7297 12.3199 24.9383 11.3181 24.9173H8.56913V30.1875H5.75V15.8075H11.4954ZM8.56718 22.5432H10.9919C11.76 22.5993 12.522 22.3724 13.1343 21.9054C13.3779 21.7487 13.5741 21.5285 13.7018 21.2685C13.8294 21.0086 13.8837 20.7187 13.8588 20.4301C13.8588 18.8402 12.9327 18.0453 11.0805 18.0453H8.56718V22.5432Z",
    fill: "#F9F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_3752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.23a8f3013606c469475df73184360a37.svg";
export { ForwardRef as ReactComponent };